import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { NavigationService } from "@services/navigation.service";
import { OrdonnanceCreationService } from "@featuresAY/ordonnance-web-ay/services/ordonnance-creation.service";
import { NavigationFlag } from "@enums/navigation-flag.enum";

@Component({
	standalone: false,
	selector: "app-confirmation-creation-modal",
	templateUrl: "./confirmation-creation-modal-ay.component.html",
	styleUrls: ["./confirmation-creation-modal-ay.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationCreationModalAyComponent {
	constructor(
		private navigationService: NavigationService,
		public dialogRef: MatDialogRef<ConfirmationCreationModalAyComponent>,
		private ordoCreationService: OrdonnanceCreationService,
	) {}

	goToCreateOrdo() {
		this.ordoCreationService.resetStoreOrdonnanceCreation();
		this.dialogRef.close(NavigationFlag.CreationOrdo);
	}

	goToCompleteDossierPatient() {
		this.dialogRef.close(NavigationFlag.CompleteDossierPatient);
	}

	close() {
		this.dialogRef.close(null);
	}
}
